import React, { useEffect, useState } from 'react';
import { Slide } from '@mui/material';
import CART_LOGO from '@/assets/images/website_logo_transparent_background.png';
import useAuth from '@/hooks/useAuth';
import useGlobalSpinnerContext from '@/hooks/useGlobalSpinner';
import styles from './ApplicationLoadingPage.module.scss';

const ApplicationLoadingPage = () => {
  const authService = useAuth();
  const { firstTimeLoaded } = useGlobalSpinnerContext();
  const [displayPageLoading, setDisplayPageLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!firstTimeLoaded) {
        setDisplayPageLoading(false);
      }
    }, 15000); // 15 seconds

    return () => clearTimeout(timer);
  }, [firstTimeLoaded]);

  useEffect(() => {
    if (authService.isLoading || (!authService.isLogged && !authService.isLoading) || !firstTimeLoaded) {
      setDisplayPageLoading(true);
    } else {
      setDisplayPageLoading(false);
    }
  }, [authService.isLoading, authService.isLogged, firstTimeLoaded]);

  return (
    <Slide in={displayPageLoading} appear={false} timeout={550} direction="down" mountOnEnter unmountOnExit>
      <div className={styles.LoadingScreenContainer}>
        <div className={styles.LoadingScreenImgContainer}><img id="logo" src={CART_LOGO} alt="Cart Logo" /></div>
      </div>
    </Slide>
  );
};

export default ApplicationLoadingPage;
